import { get, userId } from './get';
import { postUserScore, postUserName } from './post';

export const ranking = {
  get,
  userId,
  postUserScore,
  postUserName,
};
